<template>
  <span class="options">
    <a @click.stop="showModal = true">
      <i class="fa fa-gear fa-fw"></i>
    </a>
    <ez-modal v-if="showModal" @close="showModal = false" size="m-tiny">
      <h3>Options</h3>
      <div class="row">
        <div class="col-7">
          <ez-modal-delete
            class="text-left"
            v-if="isOwner || isAdmin"
            @deleteData="$emit('deleteData')"
          >Are you sure you want to delete
            <strong>{{ item.name || item.title }}</strong>?
          </ez-modal-delete>
          <button class="btn btn-success" @click.stop="cloneData()">Clone</button>
        </div>
        <div class="col text-right">
          <button class="btn btn-secondary" @click.stop="showModal = false">Cancel</button>
        </div>
      </div>
    </ez-modal>
  </span>
</template>

<script>
import EzModalDelete from "@/components/shared/_VueEzModalDelete";
import modal from "@/mixins/vue-ez-modal";
import { mapState, mapGetters } from "vuex";

export default {
  name: "vue-ez-modal-options",
  components: {
    EzModalDelete
  },
  mixins: [modal],
  props: ["item"],
  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapState({
      user: state => state.session.user
    }),
    isOwner() {
      return this.item._user && this.user._id === this.item._user._id;
    }
  },
  methods: {
    cloneData() {
      this.$emit("cloneData");
      this.showModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/_global";

.options {
  // color: $body-color;
}

.danger {
  color: $danger;
}
h3 {
  margin-bottom: 1rem;
}
a,
a:not([href]):not([tabindex]) {
  color: $gray-400;

  &:hover,
  &:focus {
    color: darken($gray-400, 15%) !important;
  }
}
</style>
